<template>
  <div />
</template>
<script>
import VueCookies from 'vue-cookies'
import { mapActions } from 'vuex'
export default {
  name: 'StoreToken',
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  created() {
    const isRegistration = this.token.indexOf('registration/') >= 0
    let token = this.token
    if (isRegistration) {
      token = token.replace('registration/', '')
      VueCookies.set('registration', true)
    }
    this.storeToken({
      token: token,
    }).then(() => {
      if (process.env.VUE_APP_HAS_SEO_PAGES) {
        window.opener.document.location.href = '/app'
      } else {
        window.opener.location.reload()
      }
      window.close()
    })
  },
  mounted() {
    try {
      if (typeof ga !== 'undefined') {
        // eslint-disable-next-line no-undef
        ga('set', 'referrer', window.location.href)
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapActions({
      storeToken: 'auth/storeToken',
    }),
  },
}
</script>
